import Vue from 'vue'
import Vuex from 'vuex'
// import router from '.../router/index'
// import router from '.'

Vue.use(Vuex)
// Vue.use(router)

const state = {
    user: null,//{}, //
    token: ""
}

const getters = {
    user(state) {
        var user = null;
        var u = JSON.parse(localStorage.getItem("user"));
        if (u) {
            user = u;
        }
        state.user = user;
        return state.user;
    },
    token(state) {
        return state.token;
    }
}

const actions = {
    login({ commit }, userlogin) {
        fetch(host + '/api/auth/login', {
            mode:"cors",
            credentials: "include",
            method: "Post",
            body: JSON.stringify(userlogin.user)
        }).then(response =>response.json())
            .then(data => {
                debugger;
                if (data.Success) {
                    commit("setUser", data.Data);
                    localStorage.setItem("user", JSON.stringify(data.Data));
                    localStorage.setItem("token",data.Data.Token)
                    userlogin.router.go(-1);
                }
                else{
                    alert(data.Message)
                }
            })
            .catch(ex => { console.log(ex) })
    },
    logout({ commit }) {
        // fetch(host + "/api/auth", {
        //     method: "GET",
        //     credentials: 'include',
        //     mode: "cors",
        //     body: ""
        // }).then(response => response.json())
        //     .then(data => {
        //         if (data.Success) {
        //             commit('setUser', null);
        //             localStorage.removeItem("user");
        //         }
        //     })

        commit('setUser', null);
        localStorage.removeItem("user");
    },
    islogin({ commit }) {
        var user = null;
        var u = JSON.parse(localStorage.getItem("user"));
        if (u) {
            user = u;
        }
        // state.user = user;
        commit("setUser", user);
        return state.user;
    }
}

const mutations = {
    setUser(state, data) {
        state.user = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
